import { render } from "./EditorAnswer.vue?vue&type=template&id=63c5024c"
import script from "./EditorAnswer.vue?vue&type=script&lang=js"
export * from "./EditorAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__